import Vue from 'vue';
import Buefy from 'buefy';
import TreeView from "vue-json-tree-view";

import 'buefy/dist/buefy.css';

import Notify from '@/plugins/Notify.js';

import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

Vue.use(Buefy, {
  defaultIconPack: 'fas'
});
Vue.use(Notify);
Vue.use(TreeView);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
